<template>
  <div
    class="ruleDetail"
    id="bookingRuleDetail"
    :class="getCustomClass()"
    ref="ruleDetail"
  >
    <div class="packageRuleDetail">
      <div class="rule-item" :ref="'ruleItem'+index"
           v-for="(item, index) in policyContentList"
           :key="index" v-show="isShowSpecialBooking || item.categoryId!==6">
        <div class="rule-item-title">
          <div class="rule-item-title-line"></div>
          {{ item.contentType }}
        </div>
        <div v-if="item.categoryId === 3" class="insurance_txt">
          <div class="visa_right__titlt">签证说明：</div>
          <div class="policy-text" v-html="item.content"></div>
          <template v-if="item&&item.insuranceContent">
            <div class="visa_right__titlt">保险说明：</div>
            <div class="policy-text" v-html="item.insuranceContent"></div>
          </template>
          
        </div>
        <div v-else class="rule-item-text">
          <div v-html="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isHkSpecialCruise } from "@/utilities/tools";
import api from "@/api";
export default {
  name: "PolicyContent",
  components: {
  },
  props: {
    visaContent: {
      type: Object,
      default() {
        return {
          visaContent: "",
          hkGuestContent: "",
          insuranceContent: "",
          insuranceBrief: "",
        };
      },
    },
    departureCode: {
      type: String,
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isSevenDayNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showBankPopup: {
      type: Function,
    },
    currentTab: {
      type: Number,
      default() {
        return -1;
      },
    },
    customClass: {
      type: String,
    },
    hasNrp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hasRp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isShowSpecialBooking: {
      type: Boolean,
      default() {
        return false;
      },
    },
		shipCode: {
			type: String,
			default() {
				return "";
			}
		},
    sailDate: {
      type: String
    },
    outsideTop: {
      type: Number,
      default() {
        return 0;
      },
    },
    isDownPayCruise: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showRow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getPolicy()
  },
  data() {
    return {
      policyContentList:[]
    }
  },
  methods: {
    getCustomClass() {
      let customClass = {};
      if (this.customClass && this.customClass.length > 0) {
        customClass[this.customClass] = true;
      }
      return customClass;
    },
    async getPolicy() {
      this.$loading.show();
      const userToken = this.$store.state.user.userToken;
      let requestData = {
        userName: userToken,
        isTui: this.showRow,
      }
      let params = {
        shipCode:this.shipCode,
        sailDate:this.sailDate,
        showNrp:this.hasNrp,
        hasRp:this.hasRp
      }
      const { data } = await api.booking.getPolicyContentList(requestData,params);
      if (data) {
        this.policyContentList = data;
      }
      this.$loading.hide();
    },
  },
  computed: {
    boardingTime() {
      return "11:30-15:00";
    },
    departureCity() {
      switch (this.departureCode) {
        case "BAO":
          return "上海";
        case "TSN":
          return "天津";
        case "HKG":
          return "香港";
        case "SZX":
          return "深圳";
        default:
          return "";
      }
    },
    portAddress() {
      switch (this.departureCode) {
        case "BAO":
          return "上海市宝山区吴淞口宝杨路1号";
        case "TSN":
          return "天津市塘沽区东疆路东疆保税港区";
        case "HKG":
          return "九龙承丰路33号(入口位於祥业街)";
        case "SZX":
          return "深圳南山区蛇口海运路1号蛇口邮轮中心";
        default:
          return "";
      }
    },
		isShowNrp () {
			return this.shipCode !== 'WN'
		},
		isShowRp () {
			return true;
		},
    isHkSpecialCruise() {
      return isHkSpecialCruise(
        this.shipCode,
        this.sailDate,
        this.departureCode
      );
    },
  },
  watch: {
    currentTab(newTab) {
      console.log(newTab)
      if (newTab >= 0) {
        const refName = "ruleItem" + (newTab-1);
        const ruleItem = this.$refs[refName];
        if (ruleItem) {
          this.$refs.ruleDetail.scroll({
            top: ruleItem[0].offsetTop - 50 - this.outsideTop,
            behavior: "auto",
          });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ruleDetail {
  height: 100%;
  overflow: scroll;
}
.cruiseDetail {
  margin-top: 60px;
  padding-bottom: 60px;
}
.rule-item {
  margin-bottom: 10px;
  padding: 0 20px 12px;
  font-size: 12px;
  line-height: 20px;
  color: #666;
  letter-spacing: 0;
  background-color: #fff;
  .rule-item-title {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 17px 0 7px;
    font-size: 14px;
    line-height: 20px;
    color: #4a90e2;
    font-weight: bold;
    .rule-item-title-line {
      width: 3px;
      height: 12px;
      margin-right: 6px;
      background-color: #4a90e2;
    }
  }
  .rule-item-text {
    .visa_right__titlt {
      font-weight: bold;
      margin-top: 16px !important;
      color: #333;
    }
  }
}

.guestInfo {
  margin: 0 15px 17px 25px;
  .rule-item {
    padding-left: 8px;
    border-bottom: 1px solid #cccccc;
    margin-bottom: 20px;
  }
  .rule-item:last-child {
    border: none;
  }
}

.special-rule-item-title {
  font-weight: bold;
  margin-top: 16px !important;
  color: #333;
}
</style>

<style lang="less">
#bookingRuleDetail .rule-item .insurance_txt .policy-text p img{
  max-width:100% !important;
}
#bookingRuleDetail .rule-item .rule-item-text p img {
  max-width: 100% !important;
}
#bookingRuleDetail .rule-item .rule-item-text p {
  margin: 0px;
}
#bookingRuleDetail .rule-item .rule-item-text p.title {
  display: none !important;
}
.insurance_html {
  .insurance_txt {
    .visa_right__titlt {
      font-weight: bold;
      margin-top: 16px !important;
      color: #333;
    }
  }
}
.visa_right__titlt{
  font-size: 12px;
  margin-bottom: 4px;
  margin-top: 12px;
  
  color: #000 !important;
}
.payWays {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
}
.payWays.wechatPay {
  margin-top: 5px;
}
.payWays .payIcon {
  width: 30px !important;
}
.reservation_desc ul {
  padding-left: 15px;
}
.reservation_desc ul li {
  list-style: disc;
}
.reservation_desc ul::before {
  display: none;
}
.reservation_desc ul::after {
  display: none;
}
</style>
